export const OPENER_LOCK_KEY = "dsc-doc-viewer-opener";
